import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import TR from './../Trans';
import navigationStore from './navigation';
import performanceStore from './performance';
import accountStore from './account';
import settingsStore from './settings';
import singersStore from './singers';
import newTracksStore from './newTracks';
import favoritesStore from './favorites';
import catalogStore from './catalog';
import environmentStore from './environment';
import musicStore from './music';
import musicPlayerStore from './musicPlayer';
import newsStore from './news';
import playerStore from './player';
import searchStore from './search';
import songListStore from './songList';
import homeStore from './home';
import timeoutsStore from './timeouts';
import IntervalService from './../services/intervals';
import bgFiltersStore from './bgFilters';
import bgPlaylistsStore from './bgPlaylists';
import bgPerformanceStore from './bgPerformance';
import bgStylesStore from './bgStyles';
import bgSearchStore from './bgSearch';
import statusStore from './status';
import captchaStore from './captcha';
import muvikaAttrs from './../attrs';
import songbookQueueStore from './songbookQueue';

const sessionExpiredCode = 2004;

const initialState = {
  isSessionOpen: false,
  isSessionOpening: false,
  isThrownOut: false,
  sessionToken: "",
  isLoggedIn: false,
  isAckSmartQ: false,
  session: null,
  songbookCode: null,
  isSongbookWelcomeRead: false,
  isSongbookPublicMode: false,
  isSongbookPublicBoothMode: false,
  isLoginSeqErrors: false,
  isLoginSeqError: false,
  isWaiting: false,
  requestCount: 0
};

const songbookSessionStore = create(
  persist(
    (set, get) => ({
      ...initialState,
      reset: () => {
        set(initialState);
      },
      setNormalMode: () => {
        set({ isSongbookPublicBoothMode: false, isSongbookPublicMode: false });
      },
      setPublicMode: () => {
        set({ isSongbookPublicBoothMode: false, isSongbookPublicMode: true });
      },
      setBoothMode: () => {
        set({ isSongbookPublicBoothMode: true, isSongbookPublicMode: false });
      },
      zeroRequestCount: () => {
        set({ requestCount: 0 });
      },
      incRequestCount: () => {
        set({ requestCount: get().requestCount + 1 });
      },
      setThrownOut: (isThrownOut) => {

        set({ isThrownOut: isThrownOut });
      },
      ackSmartQ: () => {
        set({ isAckSmartQ: true });
      },
      setIsSongbookWelcomeRead: (isRead) => {

        set({ isSongbookWelcomeRead: isRead });
      },
      openSession: (language) => {

        set({ isWaiting: true, isSessionOpening: true });
        MuvikaService.openSession(language)
          .then(function (res) {
            if (res.data.error) {
              set({ isSessionOpen: false, isLoggedIn: false, isThrownOut: false, isWaiting: false, isSessionOpening: false });
              if (res.data.error.details.length > 0) {
                messageStore.getState().setError("", res.data.error.code, res.data.error.details);
              } else {
                messageStore.getState().setError("", 1000010, TR.cm_session_start_failed);
              }
            } else {
              //console.log(res.data.session_token)
              TR.setLanguage(language);
              document.title = TR.ww_page_title;
              localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(language));
              set({ isSessionOpen: true, sessionToken: res.data.session_token, isThrownOut: false, isWaiting: false, isSessionOpening: false });
            }
          })
          .catch(function () { });
      },
      updateSession: (sessionToken, language) => {

        MuvikaService.updateSession(sessionToken, language)
          .then(function (res) {
            if (res.data.error) {
              if (res.data.error.code === sessionExpiredCode) {
                get().openSession(language);
              } else {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            } else {
              TR.setLanguage(language);
              document.title = TR.ww_page_title;
              localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(language));
              environmentStore.getState().getEnvironment(sessionToken, language);
            }
          })
          .catch(function () { });
      },
      clearSession: () => {
        set({ isSessionOpen: false, isLoggedIn: false, sessionToken: "", session: null, isThrownOut: false });
      },
      loginSeq: (sessionToken, isFirst, isSongbookPublicMode = false, isSongbookPublicBoothMode = false) => {

        let settingsPromise = MuvikaService.getSettings(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              settingsStore.setState({ isSet: true, settings: res.data.data });
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { });
        let playQueuePromise = MuvikaService.getPlayQueue(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let playQueue = { ...res.data.data };
              if (playQueue) {
                if (playQueue.items) {
                  let duration = 0;
                  for (let i = 0; i < playQueue.items.length; i++) {
                    playQueue.items[i].position = i;
                    playQueue.items[i].incoming = duration;
                    duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
                  }
                  if (playQueue.items.length > 0) {
                    performanceStore.setState({ currentPerformance: playQueue.items[0] });
                  }
                  performanceStore.setState({ playQueue: playQueue, playQueueDuration: duration });
                }
              }
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { });
        let latestPromise = MuvikaService.getLatest(sessionToken, 25, 1)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              newTracksStore.setState({ isSet: true, tracks: res.data.data.items, totalCount: res.data.data.items_total, isWaiting: false });

            }
          })
          .catch(function () { });

        Promise.all([settingsPromise, playQueuePromise, latestPromise])
          .then(function () {
            if (get().isLoginSeqErrors) {
              if (isFirst) {
                setTimeout(() => {
                  get().loginSeq(sessionToken, false);
                }, 5000);
              } else {
                set({ isLoggedIn: true, isLoginSeqError: true, isWaiting: false, isSongbookWelcomeRead: false, isSongbookPublicMode: isSongbookPublicMode, isSongbookPublicBoothMode: isSongbookPublicBoothMode });
              }
            } else {
              set({ isLoggedIn: true, isLoginSeqError: false, isWaiting: false, isSongbookWelcomeRead: false, isSongbookPublicMode: isSongbookPublicMode, isSongbookPublicBoothMode: isSongbookPublicBoothMode });
            }
          });
      },
      openSessionAndLogin: (songbookId, captchaId, captchaCode, isSongbookPublicMode, isSongbookPublicBoothMode) => {

        set({ isWaiting: true, isSessionOpening: true });
        MuvikaService.openSession()
          .then(function (res) {
            if (res.data.error) {
              set({ isSessionOpen: false, isLoggedIn: false, isThrownOut: false, isWaiting: false, isSessionOpening: false });
              if (res.data.error.details.length > 0) {
                messageStore.getState().setError("", res.data.error.code, res.data.error.details);
              } else {
                messageStore.getState().setError("", 1000010, TR.cm_session_start_failed);
              }
            } else {
              set({ isSessionOpen: true, sessionToken: res.data.session_token, isThrownOut: false, isWaiting: false, isSessionOpening: false });
              get().login(songbookId, captchaId, captchaCode, isSongbookPublicMode, isSongbookPublicBoothMode);
            }
          })
          .catch(function () { });
      },
      login: (songbookId, captchaId, captchaCode, isSongbookPublicMode = false, isSongbookPublicBoothMode = false) => {

        set({ isWaiting: true });
        console.log(captchaId + " " + captchaCode);
        const sessionToken = get().sessionToken;
        MuvikaService.songbookLogin(sessionToken, songbookId, captchaId, captchaCode)
          .then(function (res) {
            //console.log(res);
            if (res.data.error) {
              set({ isLoggedIn: false, isWaiting: false });
              captchaStore.getState().createCaptcha(sessionToken);
              if (res.data.error.code === sessionExpiredCode) {
                get().openSessionAndLogin(songbookId, captchaId, captchaCode, isSongbookPublicMode, isSongbookPublicBoothMode);
              } else {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            } else {
              let session = res.data.data;
              let language = session.account.language.toLowerCase();
              TR.setLanguage(language);
              captchaStore.getState().reset();
              document.title = TR.ww_page_title;
              localStorage.setItem(muvikaAttrs.service + "-songbook-songbook-code", songbookId);
              localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(language));
              set({ session: res.data.data });
              get().loginSeq(sessionToken, true, isSongbookPublicMode, isSongbookPublicBoothMode);
            }
          })
          .catch(function () { });
      },
      logout: () => {
        const sessionToken = get().sessionToken;
        MuvikaService.logout(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              accountStore.getState().reset();
              catalogStore.getState().reset();
              environmentStore.getState().reset();
              favoritesStore.getState().reset();
              messageStore.getState().reset();
              musicStore.getState().reset();
              musicPlayerStore.getState().reset();
              navigationStore.getState().reset();
              newsStore.getState().reset();
              homeStore.getState().reset();
              newTracksStore.getState().reset();
              performanceStore.getState().reset();
              playerStore.getState().reset();
              searchStore.getState().reset();
              settingsStore.getState().reset();
              singersStore.getState().reset();
              songListStore.getState().reset();
              timeoutsStore.getState().reset();
              captchaStore.getState().reset();
              bgFiltersStore.getState().reset();
              bgStylesStore.getState().reset();
              bgPerformanceStore.getState().reset();
              bgSearchStore.getState().reset();
              bgPlaylistsStore.getState().reset();
              musicPlayerStore.getState().reset();
              
              IntervalService.clearSongbookInterval();
              IntervalService.clearSongbookPlayqueueInterval();
              IntervalService.clearNewTracksInterval();
              localStorage.removeItem(muvikaAttrs.service + "-songbook-public-mode");
              localStorage.removeItem(muvikaAttrs.service + "-songbook-booth-mode");
              localStorage.removeItem(muvikaAttrs.service + "-songbook-songbook-code");
              set({
                isSessionOpening: false,
                isThrownOut: false,
                isLoggedIn: false,
                isAckSmartQ: false,
                isSongbookWelcomeRead: false,
                isSongbookPublicMode: false,
                isSongbookPublicBoothMode: false,
                isLoginSeqErrors: false,
                isLoginSeqError: false,
                isWaiting: false,
                requestCount: 0
              });
            }
          })
          .catch(function () { });
      },
      logoutChange: (songbookCode, isPublicMode, isBoothMode) => {
        const sessionToken = get().sessionToken;
        MuvikaService.logout(sessionToken)
          .then(function (res) {
            accountStore.getState().reset();
            catalogStore.getState().reset();
            environmentStore.getState().reset();
            favoritesStore.getState().reset();
            messageStore.getState().reset();
            musicStore.getState().reset();
            musicPlayerStore.getState().reset();
            navigationStore.getState().reset();
            newsStore.getState().reset();
            homeStore.getState().reset();
            newTracksStore.getState().reset();
            performanceStore.getState().reset();
            playerStore.getState().reset();
            searchStore.getState().reset();
            settingsStore.getState().reset();
            singersStore.getState().reset();
            songListStore.getState().reset();
            timeoutsStore.getState().reset();
            captchaStore.getState().reset();
            IntervalService.clearSongbookInterval();
            IntervalService.clearSongbookPlayqueueInterval();
            IntervalService.clearNewTracksInterval();
            localStorage.removeItem(muvikaAttrs.service + "-songbook-public-mode");
            localStorage.removeItem(muvikaAttrs.service + "-songbook-booth-mode");
            localStorage.removeItem(muvikaAttrs.service + "-songbook-songbook-code");
            set({
              isSessionOpening: false,
              isThrownOut: false,
              isLoggedIn: false,
              isAckSmartQ: false,
              isSongbookWelcomeRead: false,
              isSongbookPublicMode: false,
              isSongbookPublicBoothMode: false,
              isLoginSeqErrors: false,
              isLoginSeqError: false,
              isWaiting: false,
              requestCount: 0
            });
            var href = window.location.href;
            let hrefSplitted = href.split("?");
            if (hrefSplitted.length > 1) {
              href = hrefSplitted[0];
            }
            let publicParam = "public_mode=1&songbook_code=" + songbookCode;
            let boothParam = "booth_mode=1&songbook_code=" + songbookCode;
            console.log("songbookcheck", isPublicMode ? publicParam : boothParam);
            if (isPublicMode || isBoothMode) {
              window.location.href = href + "?" + (isPublicMode ? publicParam : boothParam);
            } else {
              window.location.href = href + "?songbook_code=" + songbookCode;
            }
          })
          .catch(function () { });
      }
    }
    ),
    {
      name: muvikaAttrs.service + '-songbook-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default songbookSessionStore;